import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import MarkdownText from '../MarkdownText';
import styles from './styles';
var useStyles = createUseStyles(styles);
var PageTitle = function PageTitle(props) {
  var classesProp = props.classes,
    className = props.className,
    Tag = props.Tag,
    text = props.text;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  return /*#__PURE__*/React.createElement(MarkdownText, {
    className: cx(classes.container, className),
    tag: Tag,
    inline: true,
    text: text
  });
};
PageTitle.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  Tag: PropTypes.string,
  text: PropTypes.string.isRequired
};
PageTitle.defaultProps = {
  className: null,
  classes: {},
  Tag: 'h1'
};
export default withMemo()(PageTitle);